export default __webpack_public_path__ + "static/media/Wristwraps of the Firebrand.b7e524a4.jpg";